import { NavHashLink } from 'react-router-hash-link'
import kebabCase from 'lodash.kebabcase'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'

import useUserAccountType from 'utils/hooks/useUserAccountType'
import { VerticalOptions } from '../helper'
import styles from '../_.module.css'

interface CategorySidebarProps {
  subCategories: SubCategories[]
  recentVerticals: VerticalOptions[]
}

const recentVerticalIndex = 2

const CategorySideBar = ({
  subCategories,
  recentVerticals,
}: CategorySidebarProps): JSX.Element => {
  const location = useLocation()
  const accountType = useUserAccountType()

  if (accountType === 'standard') {
    subCategories = subCategories.filter(item => item.title !== 'Others')
  }

  useEffect(() => {
    const id = location.hash.slice(1)
    const target = document.getElementById(`nav-${id}`)
    target?.scrollIntoView({
      behavior: 'auto',
      block: 'center',
      inline: 'center',
    })
  }, [location])

  const menuItems = [
    { title: 'Popular', key: `${kebabCase('Popular Orders')}` },
    { title: 'Recent', key: `${kebabCase('Recent Orders')}` },
    ...subCategories.map(subCategory => {
      return {
        title: subCategory.title,
        key: kebabCase(subCategory.title),
      }
    }),
  ]

  if (recentVerticals.length === 0) {
    menuItems.splice(recentVerticalIndex, 1)
  }

  return (
    <div className={styles.sidebar} id="sidebar-nav">
      {menuItems.map(menuItem => (
        <NavHashLink
          id={`nav-${menuItem.key}`}
          key={menuItem.title}
          className={styles.menuItem}
          activeClassName={styles.menuItemHover}
          to={`#${menuItem.key}`}
          smooth={false}
        >
          <span className={styles.menuItemTitle}>{menuItem.title}</span>
        </NavHashLink>
      ))}
    </div>
  )
}

export default CategorySideBar
